var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { checkEqual } from '../helpers/checkEqual';
export var getActions = function (store) {
    return Object.keys(store).reduce(function (acc, item) {
        var _a;
        var key = item;
        return typeof store[key] !== 'function' ? acc : __assign(__assign({}, acc), (_a = {}, _a[key] = store[key], _a));
    }, {});
};
export var useStoreActions = function (useStore) {
    var actions = useStore(getActions, checkEqual);
    return actions;
};
